// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"611":"4586b331","661":"e83668d4"}[chunkId] + ".chunk.js";
};